// extracted by mini-css-extract-plugin
module.exports = {"container":"AddServiceToClient_container__3U_6n","row":"AddServiceToClient_row__19Rzx"};